import axios from 'axios'
export default async (url = '', data = {}, type = 'POST', isUrl = 0) => {
//const basicUrl = 'http://localhost:5000' // 本机
//const basicUrl = 'https://localhost:5001' // 本机
//const basicUrl = 'http://114.116.96.37:6604'
const basicUrl = 'https://alljapan.jhss-jp.com' // 本地测试域名http://114.116.96.37:6604
//const basicUrl = 'http://8.209.222.249:8088' // 正式域名

  type = type.toUpperCase()
  if (isUrl === 0) {
    url = basicUrl + url
  }
  try {
    if (type === 'GET') {
      const response = axios.get(url, {params: data})
      return response
    } else if (type === 'POST') {
      const response = axios.post(url, data, {headers: {'Content-Type': 'application/json utf-8'}})
      //console.log('post:' + JSON.stringify(data))
	  //console.log('post:' + data)
      return response
    } else if (type === 'DELETE') {
      const response = axios({
        method: 'delete',
        url: url,
        params: data
      })
      console.log('delete:' + JSON.stringify(data))
      return response
    } else {
      console.log(url)
      //console.log(data)
      return url + data
    }
  } catch (error) {
    throw new Error(error)
  }
}
